<template>
  <section class="columns" style="margin: 0">
    <div id="userList" class="panel is-link column" v-show="!response">
      <h4 v-show="users.length > 0" class="panel-heading">Select User:</h4>
      <div v-for="user in users" :key="user.id" class="panel-block">
        <input
          type="radio"
          name="selectedUser"
          :value="user"
          v-model="selectedUser"
          class="mr-4"
        /><label for="selectedUser">{{ toProperCase(user.username) }}</label>
      </div>
    </div>
    <div
      id="transferDetails"
      v-show="selectedUser && !response"
      class="card column ml-5"
    >
      <header class="card-header">
        <h4 class="card-header-title">Amount:</h4>
      </header>
      <div class="card-content">
        <input
          type="number"
          name="amount"
          v-model.number="amount"
          class="input is-rounded"
          min="0"
        />
      </div>

      <div
        id="buttonGroup"
        class="card-footer is-flex is-justify-content-space-around"
      >
        <button class="button is-success" id="sendButton" v-on:click="send" :disabled="pleaseWait">
          Send
        </button>
        <button
          class="button is-warning"
          id="requestButton"
          v-on:click="request"
          :disabled="pleaseWait"
  
        >
          Request
        </button>
        <button class="button is-danger" id="cancelButton" v-on:click="cancel" :disabled="pleaseWait">
          Cancel
        </button>
      </div>
      <progress class="progress is-small is-warning mt-4" max="100" v-show="pleaseWait">1%</progress>
    </div>
    <div v-show="response" style="margin: 10px">
      <article
        class="message"
        :class="{
          'is-success': message.includes('success'),
          'is-danger': !message.includes('success'),
        }"
      >
        <div class="message-header">
          <p>{{ responseHeader }}</p>
          <button
            class="delete"
            aria-label="delete"
            @click="
              response = false;
              cancel();
            "
          ></button>
        </div>
        <div class="message-body">
          {{ message }}
        </div>
      </article>
    </div>
  </section>
</template>

<script>
import userService from "../services/UserService";
import transferService from "../services/TransferService";
import accountService from "../services/AccountService";

export default {
  name: "pay-or-request",
  data() {
    return {
      selectedUser: null,
      amount: 0,
      message: "",
      response: false,
      responseHeader: "",
      pleaseWait: false
    };
  },
  methods: {
    send() {
      const transferInfo = {
        transferType: "Send",
        userFrom: this.$store.state.user.id,
        userTo: this.selectedUser.id,
        amount: this.amount,
      };

      this.tx(transferInfo);
    },
    request() {
      const transferInfo = {
        transferType: "Request",
        userFrom: this.selectedUser.id,
        userTo: this.$store.state.user.id,
        amount: this.amount,
      };
      this.tx(transferInfo);
    },
    tx(transferInfo) {
      this.pleaseWait = true;

      transferService
        .createTransfer(transferInfo)
        .then((response) => {
          if (response.status === 201) {
            this.responseHeader =
              transferInfo.transferType === "Request" ? "Request" : "Payment";
            this.message = `Your ${this.responseHeader} successfully sent!`;
            this.refreshBalance();
            this.refreshTransactions();
            this.$store.commit("ADD_TRANSACTION", response.data);
            this.response = true;
            //this.cancel();
          } else {
            alert("Response wasn't 201 (Created)");
          }
        })
        .catch((error) => {
          this.responseHeader = "Transfer failed!";
          this.message = error.response.data.message;
          this.response = true;
        })
        .finally(() => {
          this.pleaseWait = false;
        });
    },
    cancel() {
      this.reset();
      this.$router.push({ name: "home" });
    },
    reset() {
      this.transferInfo = {};
      this.selectedUser = null;
    },
    refreshBalance() {
      accountService.getBalance().then((response) => {
        this.$store.commit("SET_BALANCE", response.data.balance);
      });
    },
    refreshTransactions() {
      accountService.getTransfers().then((response) => {
        this.$store.commit("SET_TRANSACTIONS", response.data);
      });
    },
    toProperCase(str) {
      return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
  },
  computed: {
    users() {
      return this.$store.state.users;
    },
  },
  mounted() {
    userService
      .getUsers()
      .then((response) => {
        this.$store.commit("SET_USERS", response.data);
      })
      .catch(() => {
        this.responseHeader = "Something broke! ";
        this.message = "No users to display";
        this.response = true;
      });
  },
};
</script>

<!-- <style scoped>
#userList {
    display: flex;
    flex-direction: column;
}
#buttonGroup {
    display: flex;
    justify-content: space-around;
    width: 20%;
}
</style> -->